<template>
  <div class="line">
    <div class="flex-line">
      <div class="pa-2 label-line center-media-small">
        <span>{{ name }}</span>
      </div>

      <AdminLineCheckStatus :hasFile="hasFile" />

      <div class="pa-2 text-center">
        <ButtonsTooltip
          :indexName="indexName"
          :hasFile="hasFile"
          :disabled="error"
          :uploadLoading="false"
          v-on:upload-size-error="toggleError"
        />
      </div>
    </div>

    <v-scroll-y-transition>
      <div v-if="uploadSizeError">
        <p class="red--text font-weight-light text-secondary caption center-media-small px-5">
          {{ this.$t('adminVideo.uploadSizeErrorLine') }}
        </p>
      </div>
    </v-scroll-y-transition>
  </div>
</template>

<script>
import AdminLineCheckStatus from '@/components/adminVideo/AdminLineCheckStatus'
import ButtonsTooltip from '@/components/adminVideo/ButtonsTooltip'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'AdminLine',

  components: {
    AdminLineCheckStatus,
    ButtonsTooltip
  },

  props: {
    indexName: {
      type: String,
      required: true
    },
    name: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      uploadSizeError: false
    }
  },

  methods: {
    toggleError(dispatchError) {
      if (dispatchError) this.uploadSizeError = true
      else this.uploadSizeError = false
    }
  },

  computed: {
    ...mapState('adminVideo', {
      uploadLoading: state => state.uploadLoading,
      error: state => state.error
    }),
    ...mapGetters('adminVideo', ['hasMediaFile']),
    hasFile() {
      return this.hasMediaFile(this.indexName)
    }
  }
}
</script>

<style lang="sass" scoped>
.flex-line
  display: flex
  align-items: center
  @media screen and (max-width: 380px)
    flex-direction: column
    justify-content: center
  & > *
    flex: 1 1 0px

.line
  border-bottom: 1px solid #D4D4D4

.label-line
  min-width: 150px

.center-media-small
  @media screen and (max-width: 380px)
    text-align: center
</style>
